"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const ControlRendererContext_1 = __importDefault(require("../ControlRendererContext"));
const appStateSelectControlEventOnlyNew_1 = __importDefault(require("../shared/appStateSelectControlEventOnlyNew"));
const appStateSelectFunctionsDefinitions_1 = __importDefault(require("../shared/appStateSelectFunctionsDefinitions"));
const controlCreateEventCallbackFromDefinition_1 = __importDefault(require("../shared/controlCreateEventCallbackFromDefinition"));
const useAppStateSelector_1 = __importDefault(require("./useAppStateSelector"));
const useAppStateStore_1 = __importDefault(require("./useAppStateStore"));
const useControlEventCallback = ({ controlId, eventKey, }) => {
    const { functions: { processor } } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const eventDefinition = (0, useAppStateSelector_1.default)((0, appStateSelectControlEventOnlyNew_1.default)(controlId)(eventKey));
    const functionsDefinitions = (0, useAppStateSelector_1.default)(appStateSelectFunctionsDefinitions_1.default);
    const appStateStore = (0, useAppStateStore_1.default)();
    if (!eventDefinition) {
        return undefined;
    }
    return (0, controlCreateEventCallbackFromDefinition_1.default)({
        controlEvent: eventDefinition,
        controlId,
        functionsDefinitions,
        processor,
        appStateStore,
    });
};
exports.default = useControlEventCallback;
